import React, { useState, useEffect } from 'react';
import useUserAccounts, { Accounts } from 'sdk/hooks/user/useUserAccounts';
import { Input } from 'components/shared/Input';
import AuthModal from 'components/shared/modals/AuthModal';
import Button from 'components/shared/Button';
import { StringConstant } from 'utils/Constants';
import styles from './PassReset.module.scss';

type HandleNext = (params: Accounts) => void
type EmailViewProps = {
  handleNext: HandleNext
  onClose: () => void,
  onBack: () => void,
  loading: boolean,
}

function UsernameView({
  handleNext,
  onClose,
  onBack,
  loading,
}: EmailViewProps) {
  const [username, setUsername] = useState('')
  const [isSent, setIsSent] = useState(false)
  const {
    mutate: getAccounts,
    data: getAccountsData,
    isSuccess: isGetAccountsSuccess,
    isError: isGetAccountsError,
    error: getAccountsError,
    reset: resetGetAccounts,
  } = useUserAccounts({ username })

  useEffect(() => {
    if (isGetAccountsSuccess) {
      handleNext(getAccountsData)
    }
  }, [isGetAccountsSuccess])

  useEffect(() => {
    if (isGetAccountsError) {
      // @ts-ignore
      resetGetAccounts();
    }
  }, [isGetAccountsError])

  const handleEmailChange = (e: React.FormEvent<HTMLInputElement>) => {
    setUsername((e.target as HTMLInputElement).value)
    setIsSent(false)
  }

  return (
    <AuthModal
      onClose={onClose}
      onBack={onBack}
      title="Reset Password"
      showLogo
    >
      <Input
        className={styles.margin20}
        type="username"
        value={username}
        onChange={handleEmailChange}
        placeholder="Enter your username"
        error={isSent && isGetAccountsError}
        errorMessage={StringConstant.RESET_PASSWORD_ERROR_MEESAGE}
        wide
        white
      />

      <Button
        className={styles.margin20}
        disabled={Boolean(isSent)}
        onClick={() => {
          getAccounts()
          setIsSent(true)
        }}
        wide
        black
        loading={loading}
      >
        Next
      </Button>
    </AuthModal>
  )
}

export default UsernameView
